module.exports = __webpack_public_path__ + "static/media/Boy-Bedroom-3.b489a5f9.webp";